import { render, staticRenderFns } from "./InvitationAwardList.vue?vue&type=template&id=e35a1892&scoped=true&"
import script from "./InvitationAwardList.vue?vue&type=script&lang=js&"
export * from "./InvitationAwardList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationAwardList.vue?vue&type=style&index=0&id=e35a1892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35a1892",
  null
  
)

export default component.exports